import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  padding: {
    padding: '8px 16px 16px 16px',
  },
  button: {
    marginTop: 12,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  defaultModalStyle: {
    maxHeight: '95%',
  },
  npsTitle: {
    color: 'black',
    textAlign: 'left',
    fontSize: '20px',
  },
  npsContent: {
    textAlign: 'left',
  },
  npsActions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  npsButton: {
    width: '48%',
  },
  npsModalstyle: {
    position: 'absolute',
    bottom: 0,
    backgroundColor: '#F5F5F5 !important',
    boxShadow: 'none',
    width: '100%',
    marginBottom: '1%',
    textAlign: 'left',
  },
  defaultStyle: {
    width: '100%',
  },
  customStyleContext: {
    width: '50%',
    backgroundColor: '#193F9C ',
    margin: 'auto',
  },
  subTitle: {
    justifyContent: 'flex-start',
  },
  premiumGarage: {
    display: 'flex',
    '& h6': {
      marginTop: '1.5%',
    },
    '& svg.MuiSvgIcon-root': {
      color: 'rgb(76, 175, 80)',
      marginRight: '2%',
    },
  },
  listTitle: {
    fontWeight: 600,
    fontSize: 15,
    display: 'block',
    marginTop: '10px',
  },
  dialogTitlePadding: {
    marginTop: '-8px',
  },
  text: {
    fontSize: '10px',
    marginBottom: '2px',
  },
  titleText: {
    fontSize: '14px',
  },
  alertText: {
    color: '#ff0000',
  },
});
